import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { EmployerService } from 'src/app/services/employer.service';

@Component({
  selector: 'app-recruiter-want-to-job-seeker-side',
  templateUrl: './recruiter-want-to-job-seeker-side.component.html',
  styleUrls: ['./recruiter-want-to-job-seeker-side.component.scss'],
})
export class RecruiterWantToJobSeekerSideComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private empService: EmployerService,
    public dialogRef: MatDialogRef<RecruiterWantToJobSeekerSideComponent>
  ) {}

  ngOnInit(): void {
    // console.log(this.data)
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  gotologout(): void {
    this.dialogRef.close();
    localStorage.removeItem('workNigeriaToken');
    sessionStorage.removeItem('workNigeriaToken');
    localStorage.clear();
    window.localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/home']);
    this.empService.setforWSconnect(null);
  }
}
